import React from "react";
import Input, { DateInput, SelectInput } from "./Input";

export const createExerciseMods = (exercise = {}) =>
  Array.from({ length: 7 }).map((unused, index) => {
    const data = exercise[`MOD_${index + 1}`]?.split(";") || [];

    return {
      num: index + 1,
      tipoExp: data[0] || "",
      tipo: data[1] || "",
      monto: data[2] || 0,
      texto: data[3] || "",
    };
  });

const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const formatDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(
    2,
    "0"
  )}`;

export const createCurrentExerciseDefaults = (currentDate = new Date()) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  return {
    NOMBRE: `${monthNames[month]} ${year}`,
    DESDE: formatDate(new Date(year, month, 1)),
    HASTA: formatDate(new Date(year, month + 1, 0)),
    VENC: formatDate(new Date(year, month + 1, 10)),
  };
};

const ExerciseFormFields = ({
  building = {},
  values = {},
  modsData,
  onModsChange,
  register,
  errors,
  disabled = false,
  className = "",
}) => {
  const expenseTypes = (building.TIPO_EXP || "")
    .split(";")
    .filter((type) => type)
    .map((type) => ({ value: type, label: type }));

  expenseTypes.push({ value: "DIRECTO", label: "Directo" });

  const updateMod = (index, field, value) => {
    onModsChange((previous) => {
      const next = [...previous];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const firstEmptyMod = modsData.findIndex((mod) => Number(mod.monto) === 0);

  return (
    <div className={`exercise-form-fields ${className}`.trim()}>
      <Input
        label="Nombre"
        name="NOMBRE"
        errors={errors}
        autoFocus
        errMsg="Nombre Requerido"
        value={values.NOMBRE}
        register={register({ required: true })}
        disabled={disabled}
      />
      <DateInput
        label="Desde"
        name="DESDE"
        errors={errors}
        errMsg="Desde Requerido"
        autoComplete={{ dd: "01", yyyy: true }}
        value={values.DESDE}
        register={register({ required: true })}
        disabled={disabled}
      />
      <DateInput
        label="Hasta"
        name="HASTA"
        errors={errors}
        errMsg="Hasta Requerido"
        autoComplete={{ dd: new Date(2020, new Date().getMonth() + 1, 0).getDate(), yyyy: true }}
        value={values.HASTA}
        register={register({ required: true })}
        disabled={disabled}
      />
      <DateInput
        label="Vencimiento"
        name="VENC"
        errors={errors}
        errMsg="Vencimiento Requerido"
        autoComplete={{ dd: 10, yyyy: true }}
        value={values.VENC}
        register={register({ required: true })}
        disabled={disabled}
      />

      {modsData.map((mod, index) => {
        if (firstEmptyMod !== -1 && index > firstEmptyMod) return null;

        return (
          <div key={mod.num} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
            <label style={{ gridColumn: "1 / -1" }}>Modificación {mod.num}</label>
            <SelectInput
              value={mod.tipoExp}
              data={expenseTypes}
              disabled={disabled}
              onChange={(event) => updateMod(index, "tipoExp", event.target.value)}
            />
            <SelectInput
              value={mod.tipo}
              disabled={disabled}
              data={[
                { label: "Monto Extra", value: "EXTRA" },
                { label: "Monto Fijo", value: "FIJO" },
              ]}
              onChange={(event) => updateMod(index, "tipo", event.target.value)}
            />
            <Input
              placeholder="Monto"
              value={mod.monto || ""}
              disabled={disabled}
              onChange={(event) => updateMod(index, "monto", event.target.value)}
            />
            <div style={{ gridColumn: "1 / -1", marginTop: -24, marginBottom: 24 }}>
              <Input
                placeholder="Descripcion"
                value={mod.texto || ""}
                disabled={disabled}
                onChange={(event) => updateMod(index, "texto", event.target.value)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExerciseFormFields;
